import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

export function useBankAccounts() {
  const scopeKey = useScopeKey();
  return useQuery({
    queryKey: ['bank-accounts', scopeKey],
    queryFn: () => api.get('/bank-accounts'),
    staleTime: 60_000,
    enabled: scopeKey !== 'loading',
  });
}

export function useUpdateBankAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => api.patch(`/bank-accounts/${id}`, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['bank-accounts'] });
    },
  });
}
